/**
 * Liquid Cofe Theme - Main JavaScript
 * Clone of Sleek Shopify Theme (Beauty Preset)
 */

(function() {
  'use strict';

  // =============================================
  // UTILITY FUNCTIONS
  // =============================================
  function $(selector, context) {
    return (context || document).querySelector(selector);
  }
  function $$(selector, context) {
    return Array.from((context || document).querySelectorAll(selector));
  }

  // =============================================
  // CART DRAWER
  // =============================================
  var cartDrawer = {
    drawer: null,
    overlay: null,
    closeBtn: null,
    init: function() {
      this.drawer = document.getElementById('cart-drawer');
      this.overlay = document.getElementById('cart-drawer-overlay');
      this.closeBtn = document.getElementById('cart-drawer-close');
      var cartBtn = document.getElementById('cart-btn');

      if (!this.drawer) return;

      if (cartBtn) {
        cartBtn.addEventListener('click', this.open.bind(this));
      }
      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', this.close.bind(this));
      }
      if (this.overlay) {
        this.overlay.addEventListener('click', this.close.bind(this));
      }

      // Keyboard close
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && this.drawer && this.drawer.classList.contains('is-active')) {
          this.close();
        }
      }.bind(this));

      // Init quantity buttons
      this.initQtyButtons();

      // Init remove buttons
      this.initRemoveButtons();

      // Add to cart buttons
      document.addEventListener('click', function(e) {
        var btn = e.target.closest('.add-to-cart-btn');
        if (btn) {
          e.preventDefault();
          var variantId = btn.dataset.variantId;
          if (variantId) {
            this.addToCart(variantId, 1, btn);
          }
        }
      }.bind(this));
    },
    open: function() {
      if (!this.drawer) return;
      this.drawer.classList.add('is-active');
      this.drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      var cartBtn = document.getElementById('cart-btn');
      if (cartBtn) cartBtn.setAttribute('aria-expanded', 'true');
    },
    close: function() {
      if (!this.drawer) return;
      this.drawer.classList.remove('is-active');
      this.drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      var cartBtn = document.getElementById('cart-btn');
      if (cartBtn) cartBtn.setAttribute('aria-expanded', 'false');
    },
    addToCart: function(variantId, qty, btn) {
      if (!btn) return;
      var originalText = btn.textContent;
      btn.textContent = 'Adding...';
      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty || 1 })
      })
      .then(function(r) { return r.json(); })
      .then(function(data) {
        btn.textContent = '✓ Added!';
        setTimeout(function() {
          btn.textContent = originalText;
          btn.disabled = false;
        }, 2000);
        cartDrawer.updateCart();
        cartDrawer.open();
      })
      .catch(function(err) {
        console.error('Add to cart error:', err);
        btn.textContent = originalText;
        btn.disabled = false;
      });
    },
    updateCart: function() {
      // Server-rendered drawer fragment: correct currency formatting from Liquid
      fetch('/cart?view=drawer')
      .then(function(r) { return r.text(); })
      .then(function(html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fragment = doc.getElementById('cart-drawer-fragment');
        if (!fragment) return;

        var itemsEl = document.getElementById('cart-drawer-items');
        if (itemsEl) {
          itemsEl.innerHTML = fragment.innerHTML;
          var closeLink = itemsEl.querySelector('[data-drawer-close]');
          if (closeLink) {
            closeLink.addEventListener('click', function() { cartDrawer.close(); });
          }
        }

        var countEl = document.getElementById('cart-count');
        var itemCount = parseInt(fragment.dataset.itemCount || '0');
        if (countEl) {
          countEl.textContent = itemCount;
          countEl.style.display = itemCount > 0 ? 'flex' : 'none';
        }

        var totalEl = document.getElementById('cart-drawer-total');
        if (totalEl && fragment.dataset.total) {
          totalEl.textContent = fragment.dataset.total;
        }
      })
      .catch(function(err) {
        console.error('Cart refresh error:', err);
      });
    },
    initQtyButtons: function() {
      document.addEventListener('click', function(e) {
        var btn = e.target.closest('.qty-btn[data-action]');
        if (!btn) return;
        var key = btn.dataset.key;
        var action = btn.dataset.action;
        var itemEl = btn.closest('.cart-drawer__item');
        var qtySpan = itemEl ? itemEl.querySelector('.cart-drawer__item-qty span') : null;
        var currentQty = qtySpan ? parseInt(qtySpan.textContent) : 1;

        var newQty = action === 'increase' ? currentQty + 1 : Math.max(0, currentQty - 1);

        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: newQty })
        })
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          if (newQty === 0 && itemEl) {
            itemEl.remove();
          } else if (qtySpan) {
            qtySpan.textContent = newQty;
          }
          cartDrawer.updateCart();
        });
      });
    },
    initRemoveButtons: function() {
      document.addEventListener('click', function(e) {
        var btn = e.target.closest('.cart-drawer__item-remove');
        if (!btn) return;
        var key = btn.dataset.key;
        var itemEl = btn.closest('.cart-drawer__item');

        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 })
        })
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          if (itemEl) itemEl.remove();
          cartDrawer.updateCart();
        });
      });
    }
  };

  // =============================================
  // SEARCH MODAL
  // =============================================
  var searchModal = {
    modal: null,
    init: function() {
      this.modal = document.getElementById('search-modal');
      var searchBtn = document.getElementById('search-btn');
      var closeBtn = document.getElementById('search-modal-close');
      var overlay = document.getElementById('search-modal-overlay');

      if (!this.modal) return;

      if (searchBtn) {
        searchBtn.addEventListener('click', this.open.bind(this));
      }
      if (closeBtn) {
        closeBtn.addEventListener('click', this.close.bind(this));
      }
      if (overlay) {
        overlay.addEventListener('click', this.close.bind(this));
      }
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && this.modal.classList.contains('is-active')) {
          this.close();
        }
      }.bind(this));
    },
    open: function() {
      this.modal.classList.add('is-active');
      this.modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      setTimeout(function() {
        var input = document.querySelector('.search-modal__input');
        if (input) input.focus();
      }, 350);
    },
    close: function() {
      this.modal.classList.remove('is-active');
      this.modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
  };

  // =============================================
  // MOBILE MENU
  // =============================================
  var mobileMenu = {
    menu: null,
    init: function() {
      this.menu = document.getElementById('mobile-menu');
      var openBtn = document.getElementById('mobile-menu-btn');
      var closeBtn = document.getElementById('mobile-menu-close');
      var overlay = document.getElementById('mobile-menu-overlay');

      if (!this.menu) return;

      if (openBtn) openBtn.addEventListener('click', this.open.bind(this));
      if (closeBtn) closeBtn.addEventListener('click', this.close.bind(this));
      if (overlay) overlay.addEventListener('click', this.close.bind(this));
    },
    open: function() {
      this.menu.classList.add('is-active');
      this.menu.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    },
    close: function() {
      this.menu.classList.remove('is-active');
      this.menu.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
  };

  // =============================================
  // HERO SLIDESHOW
  // =============================================
  var heroSlideshow = {
    init: function() {
      $$('.hero-slideshow').forEach(function(slideshow) {
        var track = slideshow.querySelector('[id^="hero-track-"]');
        var dotsContainer = slideshow.querySelector('[id^="hero-dots-"]');
        var prevBtn = slideshow.querySelector('.hero-arrow-prev');
        var nextBtn = slideshow.querySelector('.hero-arrow-next');

        if (!track) return;

        var slides = track.children;
        var totalSlides = slides.length;
        var currentIndex = 0;
        var autoplaySpeed = parseInt(slideshow.dataset.autoplaySpeed || '5') * 1000;
        var autoplayTimer = null;

        function goTo(index) {
          currentIndex = ((index % totalSlides) + totalSlides) % totalSlides;
          track.style.transform = 'translateX(-' + (currentIndex * 100) + '%)';
          if (dotsContainer) {
            $$('.hero-slideshow__dot', dotsContainer).forEach(function(dot, i) {
              dot.classList.toggle('is-active', i === currentIndex);
            });
          }
          // Retrigger content entrance animation on the active slide
          Array.prototype.forEach.call(slides, function(slide, i) {
            slide.classList.toggle('is-active', i === currentIndex);
          });
        }

        function startAutoplay() {
          if (totalSlides <= 1) return;
          autoplayTimer = setInterval(function() {
            goTo(currentIndex + 1);
          }, autoplaySpeed);
        }

        function stopAutoplay() {
          clearInterval(autoplayTimer);
        }

        if (prevBtn) {
          prevBtn.addEventListener('click', function() {
            stopAutoplay();
            goTo(currentIndex - 1);
            startAutoplay();
          });
        }
        if (nextBtn) {
          nextBtn.addEventListener('click', function() {
            stopAutoplay();
            goTo(currentIndex + 1);
            startAutoplay();
          });
        }

        if (dotsContainer) {
          $$('.hero-slideshow__dot', dotsContainer).forEach(function(dot) {
            dot.addEventListener('click', function() {
              stopAutoplay();
              goTo(parseInt(this.dataset.index));
              startAutoplay();
            });
          });
        }

        // Touch/swipe support
        var touchStartX = 0;
        track.addEventListener('touchstart', function(e) { touchStartX = e.touches[0].clientX; }, { passive: true });
        track.addEventListener('touchend', function(e) {
          var diff = touchStartX - e.changedTouches[0].clientX;
          if (Math.abs(diff) > 50) {
            stopAutoplay();
            goTo(currentIndex + (diff > 0 ? 1 : -1));
            startAutoplay();
          }
        });

        // Pause autoplay while the user is reading/hovering the hero
        slideshow.addEventListener('mouseenter', stopAutoplay);
        slideshow.addEventListener('mouseleave', function() {
          stopAutoplay();
          startAutoplay();
        });

        goTo(0);
        startAutoplay();
      });
    }
  };

  // =============================================
  // TABBED PRODUCTS
  // =============================================
  var tabbedProducts = {
    init: function() {
      document.addEventListener('click', function(e) {
        var btn = e.target.closest('.tab-btn');
        if (!btn) return;

        var tabId = btn.dataset.tab;
        if (!tabId) return;

        var container = btn.closest('[id^="tabbed-products-"]');
        if (!container) return;

        // Update buttons
        $$('.tab-btn', container).forEach(function(b) {
          b.classList.remove('is-active');
          b.setAttribute('aria-selected', 'false');
        });
        btn.classList.add('is-active');
        btn.setAttribute('aria-selected', 'true');

        // Update panels
        $$('.tab-panel', container).forEach(function(panel) {
          panel.classList.remove('is-active');
          panel.setAttribute('hidden', '');
        });
        var targetPanel = document.getElementById(tabId);
        if (targetPanel) {
          targetPanel.classList.add('is-active');
          targetPanel.removeAttribute('hidden');
        }
      });
    }
  };

  // =============================================
  // FAQ ACCORDION
  // =============================================
  var faqAccordion = {
    init: function() {
      document.addEventListener('click', function(e) {
        var trigger = e.target.closest('.faq-item__trigger');
        if (!trigger) return;

        var item = trigger.closest('.faq-item');
        if (!item) return;

        var isOpen = item.classList.contains('is-open');

        // Close all
        $$('.faq-item').forEach(function(i) {
          i.classList.remove('is-open');
          var t = i.querySelector('.faq-item__trigger');
          if (t) t.setAttribute('aria-expanded', 'false');
        });

        // Open clicked if it was closed
        if (!isOpen) {
          item.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
        }
      });
    }
  };

  // =============================================
  // REVIEW FILTER TABS
  // =============================================
  var reviewTabs = {
    init: function() {
      document.addEventListener('click', function(e) {
        var btn = e.target.closest('.review-tab');
        if (!btn) return;

        var filter = btn.dataset.filter;
        var section = btn.closest('.reviews-section');
        if (!section) return;

        $$('.review-tab', section).forEach(function(b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');

        $$('.review-card', section).forEach(function(card) {
          if (filter === 'all' || card.dataset.category === filter) {
            card.style.display = '';
          } else {
            card.style.display = 'none';
          }
        });
      });
    }
  };

  // =============================================
  // CAPSULES SCROLLER (category circles arrows)
  // =============================================
  var capsulesScroller = {
    autoInterval: null,
    init: function() {
      var self = this;

      // Arrow click manual scroll
      $$('.capsules-arrow').forEach(function(btn) {
        btn.addEventListener('click', function() {
          var list = document.getElementById(btn.dataset.target);
          if (!list) return;
          var isRTL = getComputedStyle(list).direction === 'rtl';
          var isNext = btn.classList.contains('capsules-arrow--next');
          var dir = (isNext ? 1 : -1) * (isRTL ? -1 : 1);
          list.scrollBy({ left: dir * 320, behavior: 'smooth' });
        });
      });

      // Auto-scroll on mobile
      var lists = $$('.capsule-list');
      lists.forEach(function(list) {
        self.startAutoScroll(list);

        // Pause on touch/hover
        list.addEventListener('touchstart', function() { self.stopAutoScroll(); });
        list.addEventListener('touchend', function() { self.startAutoScroll(list); });
        list.addEventListener('mouseenter', function() { self.stopAutoScroll(); });
        list.addEventListener('mouseleave', function() { self.startAutoScroll(list); });
      });

      // Resume on resize if still mobile
      window.addEventListener('resize', function() {
        var anyList = $$('.capsule-list')[0];
        if (anyList) {
          if (window.innerWidth <= 768) {
            self.startAutoScroll(anyList);
          } else {
            self.stopAutoScroll();
          }
        }
      });
    },
    startAutoScroll: function(list) {
      this.stopAutoScroll();
      if (window.innerWidth > 768) return;
      var isRTL = getComputedStyle(list).direction === 'rtl';
      var sign = isRTL ? -1 : 1;
      this.autoInterval = setInterval(function() {
        if (!list || list.matches(':hover')) return;
        var maxScroll = list.scrollWidth - list.clientWidth;
        if (maxScroll <= 1) return;
        var current = Math.abs(list.scrollLeft);
        if (current >= maxScroll - 1) {
          list.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          var nextPos = Math.min(current + 180, maxScroll) * sign;
          list.scrollTo({ left: nextPos, behavior: 'smooth' });
        }
      }, 3000);
    },
    stopAutoScroll: function() {
      if (this.autoInterval) {
        clearInterval(this.autoInterval);
        this.autoInterval = null;
      }
    }
  };

  // =============================================
  // PROMO GRID ARROWS
  // =============================================
  var promoGridArrows = {
    init: function() {
      // Promo grid arrows
      $$('.promo-grid-arrow').forEach(function(btn) {
        btn.addEventListener('click', function() {
          var track = document.getElementById(btn.dataset.target);
          if (!track) return;
          var card = track.querySelector('.prod-promo-card');
          if (!card) return;
          var scrollAmount = card.offsetWidth + 16;
          var dir = btn.classList.contains('promo-grid-arrow--next') ? 1 : -1;
          track.scrollBy({ left: dir * scrollAmount, behavior: 'smooth' });
        });
      });
      // Trending now arrows
      $$('.trending-now-arrow').forEach(function(btn) {
        btn.addEventListener('click', function() {
          var track = document.getElementById(btn.dataset.target);
          if (!track) return;
          var card = track.querySelector('.trending-now-card');
          if (!card) return;
          var scrollAmount = card.offsetWidth + 14;
          var dir = btn.classList.contains('trending-now-arrow--next') ? 1 : -1;
          track.scrollBy({ left: dir * scrollAmount, behavior: 'smooth' });
        });
      });
      // Bundle split arrows
      $$('.bundle-split-arrow').forEach(function(btn) {
        btn.addEventListener('click', function() {
          var track = document.getElementById(btn.dataset.target);
          if (!track) return;
          var card = track.querySelector('.bundle-prod-card');
          if (!card) return;
          var scrollAmount = card.offsetWidth + 14;
          var dir = btn.classList.contains('bundle-split-arrow--next') ? 1 : -1;
          track.scrollBy({ left: dir * scrollAmount, behavior: 'smooth' });
        });
      });
    }
  };

  // =============================================
  // STICKY HEADER ADJUSTMENT
  // =============================================
  var stickyHeader = {
    init: function() {
      var header = document.getElementById('site-header');
      var announcementBar = document.getElementById('announcement-bar');

      if (!header || !announcementBar) return;

      function updateHeaderTop() {
        var annHeight = announcementBar.offsetHeight;
        header.style.top = annHeight + 'px';
      }

      updateHeaderTop();
      window.addEventListener('resize', updateHeaderTop);
    }
  };

  // =============================================
  // SCROLL ANIMATIONS
  // =============================================
  var scrollAnimations = {
    init: function() {
      if (!('IntersectionObserver' in window)) return;

      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-in');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

      var revealSelector = [
        '.product-card', '.collection-card', '.review-card', '.press-item',
        '.prod-promo-card', '.countdown-cat-card', '.trending-card',
        '.trending-now-card', '.brands-grid__cell', '.essentials-prod-card',
        '.bundle-prod-card', '.review-grid-card', '.video-card',
        '.promo-card-v2', '.features-bar__item'
        // .capsule-item intentionally excluded: this row sits right below the
        // header, already in view on first paint, so the fade/slide-up reveal
        // fires almost immediately on load — reads as a jarring "pop in"
        // instead of a scroll-triggered reveal. Render it in place instead.
      ].join(', ');

      $$(revealSelector).forEach(function(el) {
        // Stagger siblings inside the same parent for a cascade effect
        var siblingIndex = Array.prototype.indexOf.call(el.parentElement.children, el);
        el.style.setProperty('--reveal-delay', Math.min(siblingIndex, 8) * 60 + 'ms');
        el.classList.add('pre-reveal');
        observer.observe(el);
      });
    }
  };

  // =============================================
  // PRODUCT PAGE - ADD TO CART VIA FORM
  // =============================================
  // PRODUCT FORM (Unified with globalAddToCart)
  // =============================================
  var productForm = {
    init: function() {
      // Handled centrally by globalAddToCart to prevent duplicate requests
    }
  };

  // =============================================
  // CATEGORY PILLS — INFINITE MOBILE CAROUSEL
  // =============================================
  var categoryPillsCarousel = {
    track: null,
    viewport: null,
    originalWidth: 0,
    animFrame: null,
    scrollPos: 0,
    isDragging: false,
    isPaused: false,
    dragStartX: 0,
    dragStartPos: 0,
    speed: 0.8,

    init: function() {
      if (window.innerWidth > 768) return;
      this.track = document.querySelector('.category-pills__track');
      this.viewport = document.querySelector('.category-pills__viewport');
      if (!this.track || !this.viewport) return;

      var self = this;

      // Clone pills for seamless infinite loop
      var pills = Array.from(this.track.children);
      pills.forEach(function(pill) {
        var clone = pill.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        self.track.appendChild(clone);
      });

      // Measure original content width
      this.originalWidth = this.track.scrollWidth / 2;
      this.scrollPos = 0;
      this.track.style.transform = 'translateX(0)';

      // Grab-to-drag events
      this.track.addEventListener('mousedown', function(e) { self.onDragStart(e.clientX); });
      window.addEventListener('mousemove', function(e) { self.onDragMove(e.clientX); });
      window.addEventListener('mouseup', function() { self.onDragEnd(); });
      this.track.addEventListener('touchstart', function(e) { self.onDragStart(e.touches[0].clientX); }, { passive: true });
      this.track.addEventListener('touchmove', function(e) { self.onDragMove(e.touches[0].clientX); }, { passive: true });
      this.track.addEventListener('touchend', function() { self.onDragEnd(); });
      this.track.addEventListener('touchcancel', function() { self.onDragEnd(); });

      // Pause on hover
      this.track.addEventListener('mouseenter', function() { self.isPaused = true; });
      this.track.addEventListener('mouseleave', function() { self.isPaused = false; });

      // Click prevention while dragging
      this.track.addEventListener('click', function(e) {
        if (self.isDragging) e.preventDefault();
      });

      // Start animation
      this.animate();
    },

    onDragStart: function(x) {
      this.isDragging = true;
      this.dragStartX = x;
      this.dragStartPos = this.scrollPos;
      this.track.classList.add('is-dragging');
      if (this.animFrame) {
        cancelAnimationFrame(this.animFrame);
        this.animFrame = null;
      }
    },

    onDragMove: function(x) {
      if (!this.isDragging) return;
      var delta = x - this.dragStartX;
      this.scrollPos = this.dragStartPos + delta;
      this.applyTransform();
    },

    onDragEnd: function() {
      if (!this.isDragging) return;
      this.isDragging = false;
      this.track.classList.remove('is-dragging');
      this.animate();
    },

    animate: function() {
      var self = this;
      function step() {
        if (!self.isDragging && !self.isPaused) {
          self.scrollPos -= self.speed;
          self.applyTransform();
        }
        self.animFrame = requestAnimationFrame(step);
      }
      this.animFrame = requestAnimationFrame(step);
    },

    applyTransform: function() {
      var maxScroll = this.originalWidth;
      if (this.scrollPos <= -maxScroll) {
        this.scrollPos = 0;
      }
      this.track.style.transform = 'translateX(' + this.scrollPos + 'px)';
    }
  };

  // =============================================
  // COUNTDOWN CATEGORIES — AUTO-SCROLL + DRAG
  // =============================================
  var countdownCatScroll = {
    track: null,
    interval: null,
    isDragging: false,
    dragStartX: 0,
    dragScrollLeft: 0,
    isPaused: false,

    init: function() {
      if (window.innerWidth > 768) return;
      this.track = document.querySelector('.countdown-cat-grid__categories');
      if (!this.track || this.track.children.length < 3) return;

      var self = this;

      // Grab-to-drag events
      this.track.addEventListener('mousedown', function(e) { self.onDragStart(e.clientX); });
      window.addEventListener('mousemove', function(e) { if (self.isDragging) self.onDragMove(e.clientX); });
      window.addEventListener('mouseup', function() { self.onDragEnd(); });
      this.track.addEventListener('touchstart', function(e) { self.onDragStart(e.touches[0].clientX); }, { passive: true });
      this.track.addEventListener('touchmove', function(e) { if (self.isDragging) self.onDragMove(e.touches[0].clientX); }, { passive: true });
      this.track.addEventListener('touchend', function() { self.onDragEnd(); });
      this.track.addEventListener('touchcancel', function() { self.onDragEnd(); });

      // Pause on hover
      this.track.addEventListener('mouseenter', function() { self.isPaused = true; self.stopAuto(); });
      this.track.addEventListener('mouseleave', function() { self.isPaused = false; self.startAuto(); });

      // Start auto-scroll
      this.startAuto();
    },

    onDragStart: function(x) {
      this.isDragging = true;
      this.dragStartX = x;
      this.dragScrollLeft = this.track.scrollLeft;
      this.track.classList.add('is-dragging');
      this.stopAuto();
    },

    onDragMove: function(x) {
      if (!this.isDragging) return;
      var delta = x - this.dragStartX;
      this.track.scrollLeft = this.dragScrollLeft - delta;
    },

    onDragEnd: function() {
      if (!this.isDragging) return;
      this.isDragging = false;
      this.track.classList.remove('is-dragging');
      if (!this.isPaused) this.startAuto();
    },

    startAuto: function() {
      this.stopAuto();
      var self = this;
      this.interval = setInterval(function() {
        if (self.isPaused || self.isDragging) return;
        var maxScroll = self.track.scrollWidth - self.track.clientWidth;
        var next = self.track.scrollLeft + 1;
        if (next >= maxScroll) {
          self.track.scrollLeft = 0;
        } else {
          self.track.scrollLeft = next;
        }
      }, 30);
    },

    stopAuto: function() {
      if (this.interval) {
        clearInterval(this.interval);
        this.interval = null;
      }
    }
  };

  // =============================================
  // TRENDING LIST — AUTO-SCROLL + DRAG
  // =============================================
  var trendingListScroll = {
    track: null,
    interval: null,
    isDragging: false,
    dragStartX: 0,
    dragScrollLeft: 0,
    isPaused: false,

    init: function() {
      if (window.innerWidth > 768) return;
      this.track = document.querySelector('.trending-list__grid');
      if (!this.track || this.track.children.length < 3) return;

      var self = this;

      this.track.addEventListener('mousedown', function(e) { self.onDragStart(e.clientX); });
      window.addEventListener('mousemove', function(e) { if (self.isDragging) self.onDragMove(e.clientX); });
      window.addEventListener('mouseup', function() { self.onDragEnd(); });
      this.track.addEventListener('touchstart', function(e) { self.onDragStart(e.touches[0].clientX); }, { passive: true });
      this.track.addEventListener('touchmove', function(e) { if (self.isDragging) self.onDragMove(e.touches[0].clientX); }, { passive: true });
      this.track.addEventListener('touchend', function() { self.onDragEnd(); });
      this.track.addEventListener('touchcancel', function() { self.onDragEnd(); });
      this.track.addEventListener('mouseenter', function() { self.isPaused = true; self.stopAuto(); });
      this.track.addEventListener('mouseleave', function() { self.isPaused = false; self.startAuto(); });

      this.startAuto();
    },

    onDragStart: function(x) {
      this.isDragging = true;
      this.dragStartX = x;
      this.dragScrollLeft = this.track.scrollLeft;
      this.track.classList.add('is-dragging');
      this.stopAuto();
    },

    onDragMove: function(x) {
      if (!this.isDragging) return;
      this.track.scrollLeft = this.dragScrollLeft - (x - this.dragStartX);
    },

    onDragEnd: function() {
      if (!this.isDragging) return;
      this.isDragging = false;
      this.track.classList.remove('is-dragging');
      if (!this.isPaused) this.startAuto();
    },

    startAuto: function() {
      this.stopAuto();
      var self = this;
      this.interval = setInterval(function() {
        if (self.isPaused || self.isDragging) return;
        var maxScroll = self.track.scrollWidth - self.track.clientWidth;
        var next = self.track.scrollLeft + 1;
        if (next >= maxScroll) {
          self.track.scrollLeft = 0;
        } else {
          self.track.scrollLeft = next;
        }
      }, 30);
    },

    stopAuto: function() {
      if (this.interval) {
        clearInterval(this.interval);
        this.interval = null;
      }
    }
  };

  // =============================================
  // UTILITY: FORMAT MONEY
  // =============================================
  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    return '$' + amount;
  }

  // =============================================
  // FOOTER ACCORDION (mobile link columns)
  // =============================================
  var footerAccordion = {
    init: function() {
      var toggles = $$('.footer-link-col__toggle');
      if (!toggles.length) return;

      var isDesktop = function() { return window.matchMedia('(min-width: 900px)').matches; };

      // On desktop: open all, mark toggle expanded, kill the button.
      // On mobile: start closed (visually) but accessible — set max-height to 0.
      var setInitialState = function() {
        toggles.forEach(function(t) {
          var list = document.getElementById(t.getAttribute('aria-controls'));
          if (!list) return;
          if (isDesktop()) {
            t.setAttribute('aria-expanded', 'true');
            list.style.maxHeight = 'none';
          } else {
            t.setAttribute('aria-expanded', 'false');
            list.style.maxHeight = '0px';
          }
        });
      };

      setInitialState();

      toggles.forEach(function(t) {
        t.addEventListener('click', function(e) {
          if (isDesktop()) return; // desktop: non-interactive header
          e.preventDefault();
          var list = document.getElementById(t.getAttribute('aria-controls'));
          if (!list) return;
          var expanded = t.getAttribute('aria-expanded') === 'true';

          // Single-open behavior: close others.
          if (!expanded) {
            toggles.forEach(function(other) {
              if (other === t) return;
              var otherList = document.getElementById(other.getAttribute('aria-controls'));
              if (!otherList) return;
              other.setAttribute('aria-expanded', 'false');
              otherList.style.maxHeight = '0px';
            });
          }

          if (expanded) {
            t.setAttribute('aria-expanded', 'false');
            list.style.maxHeight = '0px';
          } else {
            t.setAttribute('aria-expanded', 'true');
            list.style.maxHeight = list.scrollHeight + 'px';
          }
        });
      });

      // Keep state correct on resize across the breakpoint.
      var resizeRaf;
      window.addEventListener('resize', function() {
        if (resizeRaf) cancelAnimationFrame(resizeRaf);
        resizeRaf = requestAnimationFrame(function() {
          setInitialState();
        });
      });
    }
  };

  // =============================================
  // OPTIMISTIC CART DRAWER
  //
  // /cart/add.js is a real server round trip (~700ms even after the earlier
  // redundant-request fix), and until now the drawer stayed closed for the
  // whole wait -- the shopper got no feedback beyond the button's own
  // "loading" state until the response landed. This opens the drawer and
  // shows what was just clicked (its own image/title/price, read straight
  // off the page, never invented) in the same frame as the click, then hands
  // off to the real content the instant the server confirms.
  //
  // Deliberately NOT a fake line item built to impersonate Horizon's own
  // cart-items-component markup: that component is core theme code (not
  // ours), its internal DOM shape can change under us, and the empty-cart vs
  // has-items dialog bodies are two structurally different server-rendered
  // trees (see snippets/cart-drawer.liquid) -- there is no single "line item
  // shape" to fake that is correct in both states. A self-contained overlay
  // sitting on top of whatever is currently there sidesteps all of that: it
  // never has to match, merge with, or predict Horizon's internal structure,
  // so it can never drift out of sync with it. It is removed the moment the
  // real cart:update morph (already wired below, unchanged) has run.
  // =============================================
  var optimisticDrawer = (function() {
    var STYLE_ID = 'sat2-atc-optimistic-style';
    var CARD_SCOPE =
      '.bb-pc__card, .card, product-card, quick-add-modal, .quick-add, [data-eln-standalone-card]';
    var current = null; // {el, bubbleBump}

    function ensureStyle() {
      if (document.getElementById(STYLE_ID)) return;
      var style = document.createElement('style');
      style.id = STYLE_ID;
      style.textContent =
        '.sat2-atc-optimistic{position:absolute;inset:0;z-index:5;display:flex;' +
        'flex-direction:column;justify-content:flex-end;padding:14px;pointer-events:none;' +
        'background:linear-gradient(to top,rgba(0,0,0,.06),transparent 40%)}' +
        '.sat2-atc-optimistic__card{pointer-events:auto;background:var(--color-background,#fff);' +
        'border-radius:14px;box-shadow:0 8px 24px rgba(0,0,0,.14),0 2px 8px rgba(0,0,0,.08);' +
        'padding:12px;display:flex;flex-direction:column;gap:10px;' +
        'animation:sat2-atc-in .32s cubic-bezier(.22,1,.36,1) both;' +
        'transition:opacity .28s ease,transform .28s ease}' +
        '.sat2-atc-optimistic__card.is-leaving{opacity:0;transform:translateY(6px) scale(.98)}' +
        '@keyframes sat2-atc-in{from{opacity:0;transform:translateY(14px) scale(.97)}to{opacity:1;transform:none}}' +
        '.sat2-atc-optimistic__row{display:flex;align-items:center;gap:12px}' +
        '.sat2-atc-optimistic__thumb{width:52px;height:52px;flex:none;border-radius:10px;' +
        'overflow:hidden;background:rgba(0,0,0,.06)}' +
        '.sat2-atc-optimistic__thumb img{width:100%;height:100%;object-fit:cover;display:block}' +
        '.sat2-atc-optimistic__info{min-width:0;flex:1}' +
        '.sat2-atc-optimistic__title{margin:0;font-size:13.5px;font-weight:700;line-height:1.35;' +
        'overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical}' +
        '.sat2-atc-optimistic__meta{margin:3px 0 0;font-size:12.5px;opacity:.7;display:flex;gap:8px}' +
        '.sat2-atc-optimistic__status{display:flex;align-items:center;gap:8px;font-size:12.5px;font-weight:600}' +
        '.sat2-atc-optimistic__spinner{width:14px;height:14px;flex:none;border-radius:50%;' +
        'border:2px solid rgba(0,0,0,.15);border-top-color:currentColor;animation:sat2-atc-spin .7s linear infinite}' +
        '.sat2-atc-optimistic[data-state="done"] .sat2-atc-optimistic__spinner{border:none;' +
        'background:currentColor;-webkit-mask:radial-gradient(circle 7px,transparent 6px,#000 6.4px);' +
        'mask:radial-gradient(circle 7px,transparent 6px,#000 6.4px);animation:none}' +
        '.sat2-atc-optimistic[data-state="done"] .sat2-atc-optimistic__status{color:#1f7a3d}' +
        '.sat2-atc-optimistic[data-state="error"] .sat2-atc-optimistic__spinner{display:none}' +
        '.sat2-atc-optimistic[data-state="error"] .sat2-atc-optimistic__status{color:#b3261e}' +
        '@keyframes sat2-atc-spin{to{transform:rotate(360deg)}}' +
        // ajaxAdd (below) sets submitBtn.disabled + adds the "atc-loading"
        // class synchronously, before the fetch is even sent -- but neither
        // class has ever had CSS anywhere in this theme. The button's label
        // stayed frozen for the whole ~700-900ms request with zero visual
        // acknowledgment of the click, which is what actually reads as "slow
        // to press" even though the drawer opens instantly. currentColor
        // (not a hardcoded color) so the spinner ring automatically matches
        // whichever text color the clicked button already uses.
        '.atc-loading{position:relative!important;pointer-events:none!important;cursor:wait!important}' +
        '.atc-loading>*{visibility:hidden!important}' +
        '.atc-loading::after{content:"";position:absolute;inset:0;margin:auto;width:18px;height:18px;' +
        'border-radius:50%;border:2px solid currentColor;border-top-color:transparent;opacity:.85;' +
        'animation:sat2-atc-spin .6s linear infinite}' +
        '.atc-added{animation:sat2-atc-pop .32s cubic-bezier(.34,1.56,.64,1) both}' +
        '@keyframes sat2-atc-pop{0%{transform:scale(1)}45%{transform:scale(1.05)}100%{transform:scale(1)}}' +
        '@media (prefers-reduced-motion:reduce){.sat2-atc-optimistic__card,.sat2-atc-optimistic__spinner,' +
        '.atc-loading::after,.atc-added{animation:none!important;transition:none!important}}';
      document.head.appendChild(style);
    }

    // Reads exactly what is already rendered on the page for the product
    // being added -- never fabricated. A card add reads its own card (exact
    // match, zero ambiguity). A main-product-page add has no single reliable
    // selector: this theme composes product pages from merchant-editable
    // theme blocks (ph-main-product / stp-product-main / pro-main-product-hero
    // all use different class names for title/price), so hardcoding one
    // template's classes would silently break on the others. document.title
    // is set by Shopify's own layout to "<product title> – <shop name>" on
    // every product page regardless of which block layout renders it, which
    // makes it the one genuinely template-agnostic source for the title; the
    // largest image and the first price-like element within <main> cover the
    // rest the same way.
    function capture(form, btn) {
      var card = (btn && btn.closest && btn.closest(CARD_SCOPE)) || (form && form.closest(CARD_SCOPE));
      var scope = card || document.querySelector('main') || document.body;

      var title;
      if (card) {
        // .bb-pc__card (snippets/bb-product-card.liquid) renders TWO anchors
        // to the product: .bb-pc__media (the image link -- empty textContent)
        // and .bb-pc__name (the actual title text). A bare
        // `a[href*="/products/"]` matches .bb-pc__media first in DOM order
        // and returns "", which is why this needs the specific class instead
        // of the generic href match. Falls back to aria-label (.bb-pc__media
        // carries the title there) in case a future card layout only has the
        // image anchor.
        var titleEl = card.querySelector('.bb-pc__name, a[href*="/products/"][aria-label]');
        title = titleEl ? (titleEl.textContent.trim() || titleEl.getAttribute('aria-label') || '') : '';
      } else {
        title = document.title.split(/[–—-]/)[0].trim();
      }
      if (!title) title = 'المنتج';

      var imgs = Array.prototype.slice.call(scope.querySelectorAll('img[src]'), 0, 6);
      var bestImg = null, bestArea = 0;
      imgs.forEach(function(img) {
        var area = (img.clientWidth || img.naturalWidth || 0) * (img.clientHeight || img.naturalHeight || 0);
        if (area > bestArea) { bestArea = area; bestImg = img; }
      });

      var priceEl = scope.querySelector('[class*="price"]');
      var price = priceEl ? priceEl.textContent.replace(/\s+/g, ' ').trim() : '';
      // A price block often bundles the compare-at price too ("19,900 OMR 24,900 OMR");
      // keep only the first amount so the preview doesn't show two numbers stacked together.
      if (price) {
        // Greedy on the trailing non-digit run (currency code/symbol and any
        // spacing) so it's kept whichever side of the amount it sits on
        // ("19,900 OMR" or "OMR 19,900" both survive whole); stops the moment
        // a second digit run starts, which is where a concatenated
        // compare-at price would begin.
        var m = price.match(/^[^\d]*[\d.,]+[^\d]*/);
        if (m && m[0]) price = m[0].trim();
      }

      var qtyInput = form ? form.querySelector('input[name="quantity"]') : null;
      var qty = qtyInput ? (Number(qtyInput.value) || 1) : 1;

      return {
        title: title,
        imgSrc: bestImg ? (bestImg.currentSrc || bestImg.src) : '',
        imgAlt: bestImg ? (bestImg.alt || title) : title,
        price: price,
        qty: qty
      };
    }

    function bumpBubble(delta) {
      document.querySelectorAll('.cart-bubble__text-count').forEach(function(el) {
        var n = (parseInt(el.textContent, 10) || 0) + delta;
        el.textContent = n < 0 ? 0 : n;
        var bubble = el.closest('.cart-bubble');
        if (bubble) {
          bubble.classList.toggle('visually-hidden', n <= 0);
          el.classList.toggle('hidden', n <= 0);
        }
      });
    }

    function openDrawer() {
      var drawer = document.querySelector('cart-drawer-component, dialog.cart-drawer__dialog, #cart-drawer');
      if (drawer) {
        if (typeof drawer.open === 'function') {
          drawer.open();
        } else if (typeof drawer.showDialog === 'function') {
          drawer.showDialog();
        } else if (typeof drawer.showModal === 'function') {
          drawer.showModal();
        } else {
          drawer.setAttribute('open', '');
          drawer.classList.add('is-open', 'open');
        }
      }
    }

    function show(form, btn) {
      ensureStyle();
      if (current) remove();

      openDrawer();

      var inner = document.querySelector('.cart-drawer__inner');
      if (!inner) { bumpBubble(0); return; } // no drawer markup on this page at all -- nothing to overlay

      if (getComputedStyle(inner).position === 'static') inner.style.position = 'relative';

      var data = capture(form, btn);

      var wrap = document.createElement('div');
      wrap.className = 'sat2-atc-optimistic';
      wrap.dataset.state = 'pending';
      wrap.innerHTML =
        '<div class="sat2-atc-optimistic__card">' +
          '<div class="sat2-atc-optimistic__row">' +
            (data.imgSrc
              ? '<div class="sat2-atc-optimistic__thumb"><img src="' + data.imgSrc.replace(/"/g, '&quot;') + '" alt="" loading="eager"></div>'
              : '') +
            '<div class="sat2-atc-optimistic__info">' +
              '<p class="sat2-atc-optimistic__title"></p>' +
              '<p class="sat2-atc-optimistic__meta">' +
                '<span>×' + data.qty + '</span>' +
                (data.price ? '<span></span>' : '') +
              '</p>' +
            '</div>' +
          '</div>' +
          '<div class="sat2-atc-optimistic__status">' +
            '<span class="sat2-atc-optimistic__spinner" aria-hidden="true"></span>' +
            '<span class="sat2-atc-optimistic__label">جاري الإضافة إلى السلة…</span>' +
          '</div>' +
        '</div>';
      // Text set via textContent, not concatenated into the innerHTML string above,
      // so a product title or price containing markup-like characters can't inject HTML.
      wrap.querySelector('.sat2-atc-optimistic__title').textContent = data.title;
      var metaSpans = wrap.querySelectorAll('.sat2-atc-optimistic__meta span');
      if (data.price && metaSpans[1]) metaSpans[1].textContent = data.price;

      inner.appendChild(wrap);
      bumpBubble(data.qty);
      current = { el: wrap, bumped: data.qty };
    }

    function remove() {
      if (!current) return;
      var el = current.el;
      var card = el.querySelector('.sat2-atc-optimistic__card');
      if (card) card.classList.add('is-leaving');
      setTimeout(function() {
        if (el.parentNode) el.parentNode.removeChild(el);
      }, 260);
      current = null;
    }

    function settleSuccess() {
      if (!current) return;
      var el = current.el;
      el.dataset.state = 'done';
      var label = el.querySelector('.sat2-atc-optimistic__label');
      if (label) label.textContent = 'تمت الإضافة ✓';
      setTimeout(remove, 550);
    }

    // `reason` is Shopify's own rejection text when the server rejected the add
    // (sold out, quantity rule, and so on). Without it every failure read
    // "couldn't add, try again" -- which is actively wrong for a sold-out item,
    // since retrying can never succeed. Falls back to the generic retry line
    // only when there is no server reason, which is the case a retry does fit
    // (dropped connection, timeout).
    function settleError(reason) {
      if (!current) return;
      // The optimistic card already told the shopper the item was added --
      // silently deleting it on failure would leave that claim uncorrected.
      bumpBubble(-current.bumped);
      var el = current.el;
      el.dataset.state = 'error';
      var label = el.querySelector('.sat2-atc-optimistic__label');
      if (label) label.textContent = reason || 'تعذّرت الإضافة، حاول مرة أخرى';
      // A real reason is worth reading; give it longer on screen than the
      // generic line.
      setTimeout(remove, reason ? 3600 : 2200);
    }

    return { show: show, settleSuccess: settleSuccess, settleError: settleError };
  })();

  // =============================================
  // GLOBAL AJAX ADD TO CART — SILENT (NO REDIRECT)
  // Items are added instantly (optimistic drawer above shows the result
  // immediately). Cart count updates. Drawer opens as soon as the click
  // happens, not after the server confirms.
  // =============================================
  var globalAddToCart = {
    isBusy: false,
    init: function() {
      var self = this;

      // Intercept all product form submits
      document.addEventListener('submit', function(e) {
        var form = e.target;
        if (!form) return;
        var action = form.getAttribute('action') || '';
        var isCartAdd = action.indexOf('/cart/add') !== -1 || !!form.querySelector('[name="add"]');
        if (!isCartAdd) return;

        // Let Buy-Now and COD buttons fall through normally
        var submitter = e.submitter || document.activeElement;
        if (submitter && (
          submitter.classList.contains('ph-btn--buy-now') ||
          submitter.classList.contains('eln-pc__btn') ||
          submitter.name === 'buy-now'
        )) return;

        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        if (self.isBusy) return;
        self.ajaxAdd(form, submitter);
      }, true);

      // Also catch standalone .ph-btn--atc clicks that may not trigger submit
      document.addEventListener('click', function(e) {
        var btn = e.target.closest('.ph-btn--atc, [data-ph-atc]');
        if (!btn) return;
        if (btn.classList.contains('ph-btn--buy-now') || btn.classList.contains('eln-pc__btn')) return;

        var form = btn.closest('form');
        if (!form) return;
        var action = form.getAttribute('action') || '';
        if (action.indexOf('/cart/add') === -1 && !form.querySelector('[name="add"]')) return;

        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        if (self.isBusy) return;
        self.ajaxAdd(form, btn);
      }, true);
    },

    ajaxAdd: function(form, btn) {
      var self = this;
      if (self.isBusy) return;
      self.isBusy = true;

      // Opens the drawer and shows the clicked product before the network
      // request has even been sent -- this is the "instant" part. Settled by
      // optimisticDrawer.settleSuccess()/settleError() once the real request
      // resolves, further down in this same function.
      optimisticDrawer.show(form, btn);

      // Find the actual submit button to animate
      var submitBtn = (btn && btn.type !== 'submit') ? form.querySelector('[type="submit"], [name="add"]') : btn;
      if (!submitBtn) submitBtn = btn;

      var originalHTML = submitBtn ? submitBtn.innerHTML : '';
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.setAttribute('data-original-html', originalHTML);
        submitBtn.classList.add('atc-loading');
      }

      var qtyInput = form ? form.querySelector('input[name="quantity"]') : document.querySelector('input[name="quantity"]');
      var qty = qtyInput ? (Number(qtyInput.value) || 1) : 1;

      // Collect all cart-items-component section IDs so Shopify returns updated section HTML
      var formData = new FormData(form);
      var sectionIds = [];
      document.querySelectorAll('cart-items-component[data-section-id]').forEach(function(el) {
        var sid = el.getAttribute('data-section-id');
        if (sid && sectionIds.indexOf(sid) === -1) sectionIds.push(sid);
      });
      if (sectionIds.length) {
        formData.append('sections', sectionIds.join(','));
        formData.append('sections_url', window.location.pathname);
      }

      // Check if an upsell option card (Product 1 + Product 2 + Free Gift) is active
      var activeUpsellItems = (function() {
        // The upsell override replaces the submitted form's variant outright
        // (the branch below posts activeUpsellItems and drops formData), so it
        // may only apply to the form the upsell actually belongs to.
        //
        // The choice lookup below is page-wide, which is right on a product
        // page -- the upsell sits in its own section, not inside the main
        // form, so it cannot be found by scoping to the form. It was wrong
        // anywhere a product LIST is also on screen: with the upsell popup
        // holding a checked choice, every product card's add-to-cart threw
        // away its own variant and posted the upsell's bundle instead. That
        // is the "every card adds the Shib product" bug -- reproduced live,
        // cart received 54199366844729 after clicking a card whose form
        // correctly held 54199367795001.
        //
        // A card carries its own variant and is never what the upsell is
        // upselling, so a card submit opts out and posts its own formData.
        if (form && form.closest(
          '.bb-pc__card, .card, product-card, quick-add-modal, .quick-add, [data-eln-standalone-card]'
        )) {
          return null;
        }

        var activeChoice = document.querySelector('[data-eln-choice]:checked');
        if (!activeChoice) return null;
        var chosenVariant = activeChoice.value;
        var upsellRoot = document.querySelector('[data-eln-upsell][data-placement="product"]');
        if (!chosenVariant || chosenVariant === 'base') {
          chosenVariant = (form && form.querySelector('input[name="id"]')) ? form.querySelector('input[name="id"]').value : (upsellRoot ? upsellRoot.dataset.triggerVariant : null);
        } else if (chosenVariant === 'upgrade') {
          chosenVariant = upsellRoot ? upsellRoot.dataset.upgradeVariant : null;
        }
        if (!chosenVariant) return null;

        var packTitle = '';
        var cardEl = activeChoice.closest('[data-eln-choice-card]');
        if (cardEl) {
          var nameEl = cardEl.querySelector('.eln-upsell__card-name, .eln-upsell__card-tab-title');
          if (nameEl) packTitle = nameEl.textContent.trim();
        }

        var extraStr = activeChoice.dataset.extraVariants || '';
        var extraList = extraStr.split(',').map(function(s){ return s.trim(); }).filter(Boolean);

        var bundleId = extraList.length > 0 ? ('b_' + Date.now()) : null;
        var parentProps = {};
        if (bundleId) {
          parentProps['_bundle_id'] = bundleId;
          parentProps['_bundle_role'] = 'parent';
          if (packTitle) parentProps['_pack_title'] = packTitle;
          parentProps['🎁 العرض المختار'] = packTitle || 'مشمول في الباقة';
        }

        var items = [{
          id: Number(chosenVariant),
          quantity: qty,
          properties: parentProps
        }];

        if (bundleId && extraList.length > 0) {
          extraList.forEach(function(id) {
            items.push({
              id: Number(id),
              quantity: qty,
              properties: {
                '_bundle_id': bundleId,
                '_bundle_role': 'child',
                '🎁 العرض المختار': packTitle || 'مشمول في الباقة'
              }
            });
          });
        }
        return items;
      })();

      var fetchPromise;
      if (activeUpsellItems && activeUpsellItems.length > 0) {
        var payload = { items: activeUpsellItems };
        if (sectionIds.length) {
          payload.sections = sectionIds.join(',');
          payload.sections_url = window.location.pathname;
        }
        fetchPromise = fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(payload)
        });
      } else {
        fetchPromise = fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: formData
        });
      }

      // isBusy is a page-wide re-entrancy lock, and until now nothing ever set
      // it back to false -- there was no `isBusy = false` anywhere in this
      // file. So the FIRST add-to-cart on a page latched it on and every
      // later add returned early at the guards above, silently, with no
      // request sent. That is the "adds one product then adds nothing" report:
      // verified live, a click after the first add fired zero /cart/add
      // requests. Released below as soon as the add itself resolves -- not
      // after the 1.8s button animation and drawer choreography, or a shopper
      // clicking two products quickly would lose the second one.
      //
      // The watchdog covers the one case the promise handlers cannot: a fetch
      // that never settles at all (dropped connection, backgrounded tab).
      // Without it that would leave the whole store unable to add to cart
      // until a reload.
      var released = false;
      function release() {
        if (released) return;
        released = true;
        self.isBusy = false;
      }
      var busyWatchdog = setTimeout(release, 10000);

      fetchPromise
      .then(function(res) {
        return res.json().then(function(data) {
          if (!res.ok) throw data;
          return data;
        });
      })
      .then(function(responseData) {
        clearTimeout(busyWatchdog);
        release();
        return responseData;
      })
      .then(function(responseData) {
        // /cart/add.js already returns rendered section HTML whenever we ask
        // for it, and we do -- both branches above attach `sections` to the
        // request. So this second round trip was re-fetching markup we were
        // already holding, in series, before the drawer could open. Measured
        // on the live product page: add.js 1061ms, then a further 197ms here.
        // Verified the add response carries sections before removing it.
        //
        // The fetch stays as a fallback for the case where the response
        // genuinely has none (no cart-items-component on the page, so no
        // section ids were requested).
        if (responseData && responseData.sections && Object.keys(responseData.sections).length) {
          return responseData;
        }
        var sids = sectionIds.length ? sectionIds : ['header', 'cart-drawer', 'cart-items'];
        return fetch(window.location.pathname + '?sections=' + sids.join(','))
          .then(function(r) { return r.json(); })
          .then(function(sectionsData) {
            responseData.sections = sectionsData;
            return responseData;
          })
          .catch(function() {
            return responseData;
          });
      })
      .then(function(responseData) {
        optimisticDrawer.settleSuccess();

        // Show "Added ✓" on button and restore
        if (submitBtn) {
          submitBtn.classList.remove('atc-loading');
          submitBtn.classList.add('atc-added');
          submitBtn.innerHTML = '<span style="display:flex;align-items:center;gap:6px;justify-content:center">✓ تمت الإضافة</span>';
          setTimeout(function() {
            submitBtn.classList.remove('atc-added');
            submitBtn.innerHTML = submitBtn.getAttribute('data-original-html') || originalHTML;
            submitBtn.disabled = false;
          }, 1800);
        }

        // Update cart count bubble in header
        globalAddToCart.syncCartBubble();

        // Fire the native cart:update event with sections HTML so cart-items-component morphs the drawer content
        var sections = (responseData && responseData.sections) ? responseData.sections : null;
        var cartUpdateEvent = new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: responseData,
            sourceId: 'globalAddToCart',
            data: {
              source: 'globalAddToCart',
              sections: sections
            }
          }
        });
        document.dispatchEvent(cartUpdateEvent);

        var cartAddEvent = new CustomEvent('cart:add', {
          bubbles: true,
          detail: {
            resource: responseData
          }
        });
        document.dispatchEvent(cartAddEvent);

        // Open cart drawer immediately.
        //
        // Was a flat 150ms setTimeout. The delay exists so the cart:update
        // dispatched just above can morph the drawer's contents before it is
        // shown -- that handler is synchronous, so it has already run by the
        // time this callback fires. One animation frame is enough to order it
        // after the resulting paint, and hands the shopper back ~150ms of
        // pure dead time on every single add.
        requestAnimationFrame(function() {
          var drawer = document.querySelector('cart-drawer-component, dialog.cart-drawer__dialog, #cart-drawer');
          if (drawer) {
            if (typeof drawer.open === 'function') {
              drawer.open();
            } else if (typeof drawer.showDialog === 'function') {
              drawer.showDialog();
            } else if (typeof drawer.showModal === 'function') {
              drawer.showModal();
            } else {
              drawer.setAttribute('open', '');
              drawer.classList.add('is-open', 'open');
            }
          }
          var triggerBtn = document.querySelector('[data-cart-drawer-trigger], .header-actions__cart, a[href="/cart"]');
          if (triggerBtn && (!drawer || !drawer.hasAttribute('open'))) {
            try { triggerBtn.click(); } catch(e){}
          }
        });
      })
      .catch(function(err) {
        console.warn('ATC error:', err);
        // Only a rejection thrown from the !res.ok branch above carries
        // Shopify's own wording; a genuine network failure throws a plain
        // Error whose .message is untranslated browser text ("Failed to
        // fetch"), which must not reach a shopper. Requiring the numeric
        // .status that Shopify's error bodies carry separates the two.
        var serverReason = '';
        if (err && typeof err === 'object' && typeof err.status === 'number') {
          serverReason = (typeof err.description === 'string' && err.description) ||
                         (typeof err.message === 'string' && err.message) || '';
        }
        optimisticDrawer.settleError(serverReason);
        clearTimeout(busyWatchdog);
        release();
        if (submitBtn) {
          submitBtn.classList.remove('atc-loading');
          submitBtn.innerHTML = submitBtn.getAttribute('data-original-html') || originalHTML;
          submitBtn.disabled = false;
        }
      });
    },

    syncCartBubble: function() {
      fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var parentBundleIds = new Set();
        cart.items.forEach(function(it) {
          if (it.properties && it.properties._bundle_role === 'parent' && it.properties._bundle_id) {
            parentBundleIds.add(it.properties._bundle_id);
          }
        });

        // Detect and clear any orphaned bundle child items
        var orphanedUpdates = {};
        var hasOrphans = false;
        var visibleCount = 0;

        cart.items.forEach(function(it) {
          if (it.properties && it.properties._bundle_role === 'child') {
            if (!it.properties._bundle_id || !parentBundleIds.has(it.properties._bundle_id)) {
              orphanedUpdates[it.key] = 0;
              hasOrphans = true;
            }
          } else {
            visibleCount += it.quantity;
          }
        });

        if (hasOrphans) {
          fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ updates: orphanedUpdates })
          })
          .then(function(r) { return r.json(); })
          .then(function(updatedCart) {
            globalAddToCart.syncCartBubble();
            document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: updatedCart } }));
          });
          return;
        }

        // Update the Shopify bubble count spans
        document.querySelectorAll('.cart-bubble__text-count, [data-testid="cart-bubble"], [data-s4h-cart-count]').forEach(function(el) {
          el.textContent = visibleCount > 0 ? visibleCount : '';
          el.classList.toggle('hidden', visibleCount === 0);
          if (el.classList.contains('s4h__cart-count')) {
            el.style.display = visibleCount > 0 ? 'flex' : 'none';
          }
        });

        // Show/hide the bubble wrapper
        document.querySelectorAll('.cart-bubble').forEach(function(el) {
          el.classList.toggle('visually-hidden', visibleCount === 0);
        });

        // Fire native cart events so the drawer content refreshes when it next opens
        try {
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart }, bubbles: true }));
        } catch(e) {}
      })
      .catch(function() {});
    }
  };

  // Listen for bundle parent removal / quantity change
  document.addEventListener('click', function(e) {
    var removeBtn = e.target.closest('.cart-items__remove, [data-qty-remove], button.cart-remove');
    if (!removeBtn) return;
    var row = removeBtn.closest('tr, .eln-row, [data-bundle-id]');
    if (!row) return;
    var bundleId = row.getAttribute('data-bundle-id');
    var bundleRole = row.getAttribute('data-bundle-role');
    if (bundleId && bundleRole === 'parent') {
      setTimeout(function() {
        globalAddToCart.syncCartBubble();
      }, 300);
    }
  });

  // Option card toggle support (click to select, second click on same card to deselect)
  document.addEventListener('pointerdown', function(e) {
    var card = e.target.closest('[data-eln-choice-card]');
    if (!card) return;
    var radio = card.querySelector('[data-eln-choice]');
    if (radio) {
      card.dataset.wasChecked = radio.checked ? 'true' : 'false';
    }
  });

  document.addEventListener('click', function(e) {
    var card = e.target.closest('[data-eln-choice-card]');
    if (!card) return;
    var radio = card.querySelector('[data-eln-choice]');
    if (!radio) return;

    if (card.dataset.wasChecked === 'true') {
      e.preventDefault();
      e.stopPropagation();
      radio.checked = false;
      card.dataset.wasChecked = 'false';
      card.classList.remove('eln-upsell__card--active');
      var wrap = card.closest('[data-eln-upsell], .eln-upsell-standalone-wrapper, .eln-upsell-standalone-card');
      if (wrap) wrap.dataset.userChose = '1';
    }
  });

  // =============================================
  // INITIALIZE ALL
  // =============================================
  document.addEventListener('DOMContentLoaded', function() {
    globalAddToCart.init();
    globalAddToCart.syncCartBubble();
    cartDrawer.init();
    searchModal.init();
    mobileMenu.init();
    heroSlideshow.init();
    tabbedProducts.init();
    faqAccordion.init();
    reviewTabs.init();
    capsulesScroller.init();
    categoryPillsCarousel.init();
    promoGridArrows.init();
    countdownCatScroll.init();
    trendingListScroll.init();
    stickyHeader.init();
    scrollAnimations.init();
    productForm.init();
    footerAccordion.init();
  });
  window.addEventListener('pageshow', function() {
    globalAddToCart.syncCartBubble();
  });
  document.addEventListener('cart:update', function() {
    globalAddToCart.syncCartBubble();
  });

})();
